import React from 'react'

import Svg, { Path } from 'react-native-svg'

const BackIcon = ({ size = 20, color = '#141414', ...props }) => {
  return (
    <Svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      {...props}
    >
      <Path
        d="M11.25 15.0001C11.1512 15.0007 11.0534 14.9818 10.962 14.9445C10.8706 14.9071 10.7875 14.8521 10.7175 14.7826L5.46745 9.53264C5.39716 9.46292 5.34136 9.37997 5.30329 9.28857C5.26521 9.19718 5.24561 9.09915 5.24561 9.00014C5.24561 8.90113 5.26521 8.8031 5.30329 8.71171C5.34136 8.62031 5.39716 8.53736 5.46745 8.46764L10.7175 3.21764C10.7874 3.14771 10.8704 3.09224 10.9618 3.05439C11.0531 3.01655 11.1511 2.99707 11.25 2.99707C11.3488 2.99707 11.4468 3.01655 11.5381 3.05439C11.6295 3.09224 11.7125 3.14771 11.7825 3.21764C11.8524 3.28757 11.9079 3.37059 11.9457 3.46195C11.9835 3.55332 12.003 3.65124 12.003 3.75014C12.003 3.84903 11.9835 3.94696 11.9457 4.03833C11.9079 4.12969 11.8524 4.21271 11.7825 4.28264L7.05745 9.00014L11.7825 13.7176C11.8528 13.7874 11.9085 13.8703 11.9466 13.9617C11.9847 14.0531 12.0043 14.1511 12.0043 14.2501C12.0043 14.3491 11.9847 14.4472 11.9466 14.5386C11.9085 14.63 11.8528 14.7129 11.7825 14.7826C11.7124 14.8521 11.6293 14.9071 11.5379 14.9445C11.4465 14.9818 11.3487 15.0007 11.25 15.0001Z"
        fill={color}
      />
    </Svg>
  )
}

export default BackIcon
